import { render, staticRenderFns } from "./SetupPostprocessings.vue?vue&type=template&id=d3ba12d0&scoped=true&"
import script from "./SetupPostprocessings.vue?vue&type=script&lang=js&"
export * from "./SetupPostprocessings.vue?vue&type=script&lang=js&"
import style0 from "./SetupPostprocessings.vue?vue&type=style&index=0&id=d3ba12d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ba12d0",
  null
  
)

export default component.exports